import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { useTimestamp } from "@/hooks";
import { TooltipItem } from "@/sx-layout/components/plotmap/components/TooltipItem";
import { FreeDrawText } from "@/sx-layout/components/plotmap/components/freeDraw/models";

type Props = {
  data: FreeDrawText;
  leftOrRight: "left-aligned" | "right-aligned";
};

export const TooltipText: FC<Props> = ({ data, leftOrRight }) => {
  const { t } = useTranslation();

  const { formattedInsertDatetime, insertUserNameWithCompanyName } = useTimestamp(data.timestamp);

  return (
    <div
      style={leftOrRight === "left-aligned" ? { left: "15px" } : { right: "15px" }}
      className={`
        sx-layout-tooltip
        border-4
        border-[#dea321]
        border-solid
        text-[13px]
        shadow-[0_4px_4px_0px_rgba(0,0,0,0.3)]
        rounded-lg
        p-3
        bg-[#fff]
        z-10
      `}
      id="tooltip-text"
    >
      <div className="flex mb-10">
        <span className="w-[60px] text-right font-bold mr-2 text-[#888888]">{t("text") + t("text_content")}</span>
        <span className="w-[180px] text-left whitespace-pre-wrap">{data.content}</span>
      </div>
      <br />
      <TooltipItem metaData={true} title={t("created_at")} value={formattedInsertDatetime} />
      <TooltipItem metaData={true} title={t("registered_person")} value={insertUserNameWithCompanyName} />
    </div>
  );
};
